<template>
  <div class="examination_boxs">
    <iframe :src="src" frameborder="0" class="iframes" id="iframe"></iframe>
  </div>
</template>
<script>
import { testURL } from "@/utils/config.js";
export default {
  data() {
    return {
      src: "",
    };
  },
  components: {},
  watch: {
    //监听
    $route(to, from) { },
  },
  created() {
    this.src =
      testURL +
      "/web-paper-detail-out?testPaperId=" +
      this.$route.query.testPaperId;
  },
  methods: {},
};
</script>
<style lang='scss'>
.examination_boxs {
  width: 1450px;
  height: 100vh;
  margin: 0 auto;

  .iframes {
    width: 1450px;
    height: 100%;

    .page-content {
      width: 1450px !important;
    }
  }

}
</style>
